module.exports = __webpack_public_path__ + "img/5.cf20a081.jpeg";